module.exports = __webpack_public_path__ + "img/image-viewer-error.f3db5f90.svg";